// SKIP LINK, FOCUS H1 
(function initSkipToContentFocus() {
  const skipLink = document.querySelector('a.skip-link-v2[href="#MainContent"]');
  if (!skipLink) return;

  skipLink.addEventListener('click', (e) => {
    e.preventDefault();

    const main = document.getElementById('MainContent');
    if (!main) return;

    const h1 = main.querySelector('h1');

    const focusTarget = h1 || main;

    if (!focusTarget.hasAttribute('tabindex')) {
      focusTarget.setAttribute('tabindex', '-1');
    }

    focusTarget.focus({ preventScroll: true });
    focusTarget.scrollIntoView({ block: 'start' });

    if (focusTarget !== main) {
      setTimeout(() => {
        focusTarget.removeAttribute('tabindex');
      }, 0);
    }
  });
})();


/**** COLLECTION FILTER MENU ****/
(function () {
  function initCollectionFilterMenuA11y() {
    var filterTrigger = document.getElementById('filter-trigger');
    var filterMenu = document.getElementById('filter-menu');

    if (!filterTrigger || !filterMenu) return;
    if (filterTrigger.dataset.a11yFilterBound === 'true') return;

    filterTrigger.setAttribute('aria-haspopup', 'dialog');
    filterTrigger.setAttribute('aria-expanded', 'false');
    filterTrigger.setAttribute('aria-controls', 'filter-menu');

    filterMenu.setAttribute('role', 'dialog');
    filterMenu.setAttribute('aria-modal', 'true');
    filterMenu.setAttribute('aria-label', 'Filter');

    function isMenuOpen() {
      return filterMenu.style.display === 'flex';
    }

    function syncExpandedState() {
      filterTrigger.setAttribute('aria-expanded', isMenuOpen() ? 'true' : 'false');
    }

    function getFocusableInMenu() {
      return Array.from(
        filterMenu.querySelectorAll(
          'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) {
        return !el.hasAttribute('disabled') && el.offsetParent !== null;
      });
    }

    function focusFirstInMenu() {
      var focusable = getFocusableInMenu();
      if (focusable.length) {
        focusable[0].focus();
      }
    }

    function returnFocusToTrigger() {
      filterTrigger.focus();
    }

    filterTrigger.addEventListener('click', function () {
      requestAnimationFrame(function () {
        syncExpandedState();
        if (isMenuOpen()) {
          focusFirstInMenu();
        }
      });
    });

    document.addEventListener('click', function () {
      requestAnimationFrame(syncExpandedState);
    });

    document.addEventListener('keydown', function (event) {
      if (!isMenuOpen()) return;

      if (event.key === 'Escape') {
        requestAnimationFrame(function () {
          syncExpandedState();
          returnFocusToTrigger();
        });
        return;
      }

      if (event.key === 'Tab') {
        var focusable = getFocusableInMenu();
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    var closeBtn = document.getElementById('filter-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        requestAnimationFrame(function () {
          syncExpandedState();
          returnFocusToTrigger();
        });
      });
    }

    syncExpandedState();
    filterTrigger.dataset.a11yFilterBound = 'true';
  }

  function waitForCollectionFilterMenu() {
    initCollectionFilterMenuA11y();

    var observer = new MutationObserver(function () {
      initCollectionFilterMenuA11y();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForCollectionFilterMenu);
  } else {
    waitForCollectionFilterMenu();
  }
})();

//*** CART NOTIFICATION SCREEN READER FOCUS ENTRY ***//
(function () {
  function moveFocusIntoCartNotification() {
    var notification = document.getElementById('cart-notification');
    if (!notification) return;
    if (!notification.classList.contains('active')) return;

    var closeButton = notification.querySelector('.cart-notification__close');
    if (!closeButton) return;

    closeButton.focus();
  }

  function watchCartNotification() {
    var notification = document.getElementById('cart-notification');
    if (!notification) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          notification.classList.contains('active')
        ) {
          setTimeout(function () {
            moveFocusIntoCartNotification();
          }, 100);
        }
      });
    });

    observer.observe(notification, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartNotification);
  } else {
    watchCartNotification();
  }
})();

//*** PREDICTIVE SEARCH REAL FOCUS NAVIGATION ***//
(function () {
  function getSearchInput(container) {
    return container.querySelector('input[type="search"]');
  }

  function getSearchItems(container) {
    return container.querySelectorAll(
      '#predictive-search-results-list a.predictive-search__item, #predictive-search-results-list button.predictive-search__item'
    );
  }

  function neutralizeOptionState(container) {
    var input = getSearchInput(container);
    var resultsList = container.querySelector('#predictive-search-results-list');
    var options = container.querySelectorAll('#predictive-search-results-list li');

    if (input) {
      input.removeAttribute('aria-activedescendant');
    }

    if (resultsList) {
      resultsList.removeAttribute('role');
    }

    options.forEach(function (option) {
      option.removeAttribute('role');
      option.removeAttribute('aria-selected');
    });
  }

  function moveFocusToItem(container, index) {
    var items = getSearchItems(container);
    if (!items.length) return;

    if (index < 0) index = items.length - 1;
    if (index >= items.length) index = 0;

    items[index].focus();
  }

  function setUpPredictiveSearchFocus(container) {
    var input = getSearchInput(container);
    if (!input) return;

    neutralizeOptionState(container);

    container.addEventListener(
      'keydown',
      function (event) {
        var items = getSearchItems(container);
        if (!items.length) return;

        var target = event.target;
        var onInput = target === input;
        var onItem = target.matches('#predictive-search-results-list a.predictive-search__item, #predictive-search-results-list button.predictive-search__item');

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          event.stopPropagation();

          if (onInput) {
            moveFocusToItem(container, 0);
            return;
          }

          if (onItem) {
            var currentIndex = Array.prototype.indexOf.call(items, target);
            moveFocusToItem(container, currentIndex + 1);
          }
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          event.stopPropagation();

          if (onInput) {
            moveFocusToItem(container, items.length - 1);
            return;
          }

          if (onItem) {
            var currentIndex = Array.prototype.indexOf.call(items, target);

            if (currentIndex <= 0) {
              input.focus();
              return;
            }

            moveFocusToItem(container, currentIndex - 1);
          }
        }
      },
      true
    );

    container.addEventListener(
      'input',
      function () {
        setTimeout(function () {
          neutralizeOptionState(container);
        }, 50);
      },
      true
    );

    container.addEventListener(
      'focusin',
      function () {
        neutralizeOptionState(container);
      },
      true
    );
  }

  function initPredictiveSearchA11y() {
    var predictiveSearches = document.querySelectorAll('predictive-search');

    predictiveSearches.forEach(function (container) {
      if (container.__a11yPredictiveSearchFocusInstalled) return;
      container.__a11yPredictiveSearchFocusInstalled = true;
      setUpPredictiveSearchFocus(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPredictiveSearchA11y);
  } else {
    initPredictiveSearchA11y();
  }
})();

//*** SEARCH RESULTS PAGINATION FOCUS ***//
(function () {
  function closeSearchResultsPagePredictiveSearch() {
    var predictiveSearch = document.querySelector('.template-search predictive-search');
    if (!predictiveSearch) return;

    predictiveSearch.removeAttribute('open');
    predictiveSearch.removeAttribute('results');

    var results = predictiveSearch.querySelector('[data-predictive-search]');
    if (results) {
      results.removeAttribute('style');
      results.innerHTML = '';
    }

    var input = predictiveSearch.querySelector('input[type="search"]');
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    if (typeof predictiveSearch.close === 'function') {
      predictiveSearch.close();
    }
  }

  function moveFocusToSearchResultsList() {
    if (window.location.hash !== '#search-results-top') return;

    var target = document.getElementById('search-results-top');
    if (!target) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setTimeout(function () {
          closeSearchResultsPagePredictiveSearch();

          target.setAttribute('tabindex', '-1');
          target.focus();

          target.addEventListener(
            'blur',
            function () {
              target.removeAttribute('tabindex');
            },
            { once: true }
          );
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveFocusToSearchResultsList);
  } else {
    moveFocusToSearchResultsList();
  }

  window.addEventListener('load', function () {
    setTimeout(moveFocusToSearchResultsList, 150);
  });
})();


// =============================================
// ENZUZO COOKIE CONSENT ACCESSIBILITY
// =============================================
(function () {
  if (window.__a11yEnzuzoInstalled) return;
  window.__a11yEnzuzoInstalled = true;

  var lastTrigger = null;
  var modalWasOpen = false;
  var observedWrapper = null;
  var observedModal = null;

  function isModalOpen() {
    var wrapper = document.getElementById('enzuzo-modal-wrap');
    var modal = document.getElementById('enzuzo-modal');

    if (!wrapper || !modal) return false;

    return (
      window.getComputedStyle(wrapper).display !== 'none' &&
      modal.classList.contains('enzuzo-modal-open')
    );
  }

  function getFocusableElements(modal) {
    return Array.from(
      modal.querySelectorAll(
        'a[href], ' +
        'button:not([disabled]), ' +
        'input:not([disabled]), ' +
        'select:not([disabled]), ' +
        'textarea:not([disabled]), ' +
        '[role="button"][tabindex="0"], ' +
        '[tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return (
        element.getClientRects().length > 0 &&
        element.getAttribute('aria-hidden') !== 'true'
      );
    });
  }

  function preparePreferenceControls(modal) {
    var cards = modal.querySelectorAll('.enzuzo-preferences-card');

    cards.forEach(function (card, index) {
      var control = card.querySelector('.enzuzo-card-info');
      var panel = card.querySelector('.enzuzo-preferences-content');
      var name = card.querySelector('.enzuzo-hv-preference__purpose');
      var checkbox = card.querySelector('input[type="checkbox"]');

      if (!control || !panel) return;

      if (!panel.id) {
        panel.id = 'a11y-enzuzo-panel-' + index;
      }

      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('aria-controls', panel.id);

      if (name && name.textContent.trim()) {
        control.setAttribute(
          'aria-label',
          name.textContent.trim() + ' cookie details'
        );
      }

      function syncExpandedState() {
        var isExpanded =
          !panel.classList.contains('enzuzo-content-inactive') &&
          window.getComputedStyle(panel).display !== 'none';

        control.setAttribute(
          'aria-expanded',
          isExpanded ? 'true' : 'false'
        );
      }

      syncExpandedState();

      if (control.dataset.a11yEnzuzoAccordionBound !== 'true') {
        control.dataset.a11yEnzuzoAccordionBound = 'true';

        control.addEventListener('keydown', function (event) {
          /*
          * Do not activate the accordion when the checkbox itself
          * has focus.
          */
          if (event.target !== control) return;

          if (event.key !== 'Enter' && event.key !== ' ') return;

          event.preventDefault();
          control.click();

          requestAnimationFrame(syncExpandedState);
        });

        control.addEventListener('click', function (event) {
          /*
          * A checkbox click should change consent only,
          * not open or close the accordion.
          */
          if (event.target.closest('input[type="checkbox"], label')) {
            return;
          }

          requestAnimationFrame(syncExpandedState);
        });

        var panelObserver = new MutationObserver(syncExpandedState);

        panelObserver.observe(panel, {
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }

      if (
        checkbox &&
        checkbox.dataset.a11yEnzuzoToggleBound !== 'true'
      ) {
        checkbox.dataset.a11yEnzuzoToggleBound = 'true';

        /*
        * Preserve the checkbox's native Space behavior while
        * preventing the parent accordion control from receiving
        * the same key event.
        */
        checkbox.addEventListener('keydown', function (event) {
          if (event.key === ' ') {
            event.stopPropagation();
          }
        });
      }
    });
  }

  function prepareBanner() {
    var banner = document.getElementById('ez-cookie-notification');
    if (!banner) return;

    banner.classList.add('a11y-enzuzo-banner');
    banner.setAttribute('role', 'region');
    banner.setAttribute('aria-label', 'Cookie consent');

    var icon = banner.querySelector('.enzuzo-cookie-icon svg');

    if (icon) {
      icon.removeAttribute('tabindex');
      icon.removeAttribute('role');
      icon.removeAttribute('aria-label');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
    }

    var description = banner.querySelector('.enzuzo-notification-desc');

    if (description) {
      description.removeAttribute('tabindex');
    }

    var manageButton = banner.querySelector('#notificationManagerLink');

    if (
      manageButton &&
      manageButton.dataset.a11yEnzuzoBound !== 'true'
    ) {
      manageButton.dataset.a11yEnzuzoBound = 'true';

      manageButton.setAttribute('role', 'button');
      manageButton.setAttribute('aria-haspopup', 'dialog');
      manageButton.setAttribute('aria-controls', 'enzuzo-modal');

      manageButton.addEventListener('click', function () {
        lastTrigger = manageButton;
      });

      manageButton.addEventListener('keydown', function (event) {
        if (event.key !== ' ') return;

        event.preventDefault();
        lastTrigger = manageButton;
        manageButton.click();
      });
    }

    var dismissButton = banner.querySelector('#close-notification');

    if (
      dismissButton &&
      dismissButton.dataset.a11yEnzuzoBound !== 'true'
    ) {
      dismissButton.dataset.a11yEnzuzoBound = 'true';
      dismissButton.setAttribute('role', 'button');

      dismissButton.addEventListener('keydown', function (event) {
        if (event.key !== ' ') return;

        event.preventDefault();
        dismissButton.click();
      });
    }
  }

  function prepareFooterCookiePreferences() {
    var footerLink = document.querySelector(
      'a[href="#manage_cookies"]'
    );

    if (!footerLink) return;

    footerLink.setAttribute('role', 'button');
    footerLink.setAttribute('aria-haspopup', 'dialog');
    footerLink.setAttribute('aria-controls', 'enzuzo-modal');

    if (footerLink.dataset.a11yEnzuzoFooterBound === 'true') {
      return;
    }

    footerLink.dataset.a11yEnzuzoFooterBound = 'true';

    footerLink.addEventListener('click', function () {
      lastTrigger = footerLink;
    });

    footerLink.addEventListener('keydown', function (event) {
      if (event.key !== ' ') return;

      event.preventDefault();
      lastTrigger = footerLink;
      footerLink.click();
    });
  }

  function prepareModal() {
    var wrapper = document.getElementById('enzuzo-modal-wrap');
    var modal = document.getElementById('enzuzo-modal');

    if (!wrapper || !modal) return;

    wrapper.classList.add('a11y-enzuzo-modal-wrapper');
    modal.classList.add('a11y-enzuzo-modal');

    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    var title = modal.querySelector('.enzuzo-modal-title');

    if (title) {
      title.id = 'a11y-enzuzo-modal-title';
      modal.setAttribute(
        'aria-labelledby',
        'a11y-enzuzo-modal-title'
      );
    }

    var headerText = modal.querySelector('.enzuzo-modal-header-text');

    if (headerText) {
      headerText.removeAttribute('tabindex');
    }

    preparePreferenceControls(modal);
    observeModalState(wrapper, modal);
  }

  function moveFocusIntoModal() {
    var modal = document.getElementById('enzuzo-modal');
    if (!modal || !isModalOpen()) return;

    if (modal.contains(document.activeElement)) return;

    var closeButton = modal.querySelector('#ez-close-modal');

    if (closeButton) {
      closeButton.focus();
      return;
    }

    var focusable = getFocusableElements(modal);

    if (focusable.length) {
      focusable[0].focus();
    }
  }

  function returnFocus() {
    if (!lastTrigger || !document.contains(lastTrigger)) {
      lastTrigger = null;
      return;
    }

    setTimeout(function () {
      lastTrigger.focus();
      lastTrigger = null;
    }, 0);
  }

  function syncModalState() {
    var modalIsOpen = isModalOpen();

    if (modalIsOpen && !modalWasOpen) {
      setTimeout(moveFocusIntoModal, 50);
    }

    if (!modalIsOpen && modalWasOpen) {
      returnFocus();
    }

    modalWasOpen = modalIsOpen;
  }

  function observeModalState(wrapper, modal) {
    if (wrapper !== observedWrapper) {
      observedWrapper = wrapper;

      var wrapperObserver = new MutationObserver(syncModalState);

      wrapperObserver.observe(wrapper, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    if (modal !== observedModal) {
      observedModal = modal;

      var modalObserver = new MutationObserver(syncModalState);

      modalObserver.observe(modal, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }

  function prepareEnzuzo() {
    prepareBanner();
    prepareFooterCookiePreferences()
    prepareModal();
    syncModalState();
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (!isModalOpen()) return;

      var modal = document.getElementById('enzuzo-modal');
      if (!modal) return;

      if (event.key === 'Escape') {
        var closeButton = modal.querySelector('#ez-close-modal');

        if (closeButton) {
          event.preventDefault();
          closeButton.click();
        }

        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements(modal);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (!modal.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
        return;
      }

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
        return;
      }

      if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    },
    true
  );

  function initEnzuzoAccessibility() {
    prepareEnzuzo();

    var insertionObserver = new MutationObserver(function (mutations) {
      var hasAddedNodes = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });

      if (hasAddedNodes) {
        prepareEnzuzo();
      }
    });

    insertionObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initEnzuzoAccessibility
    );
  } else {
    initEnzuzoAccessibility();
  }
})();

// =============================================
// DELAY NEWSLETTER MODAL UNTIL COOKIE CHOICE
// =============================================
(function () {
  if (window.__a11yNewsletterConsentDelayInstalled) return;
  window.__a11yNewsletterConsentDelayInstalled = true;

  var postponedNewsletter = false;
  var observedBanner = null;
  var observedDialog = null;
  var bannerObserver = null;
  var dialogObserver = null;

  function getCookieBanner() {
    return document.getElementById('ez-cookie-notification');
  }

  function getNewsletterDialog() {
    return document.getElementById('dialog');
  }

  function isCookieBannerVisible() {
    var banner = getCookieBanner();

    if (!banner) return false;

    var styles = window.getComputedStyle(banner);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      banner.getClientRects().length > 0
    );
  }

  function syncNewsletterWithCookieBanner() {
    var dialog = getNewsletterDialog();

    if (!dialog) return;

    /*
     * Klaviyo opened the newsletter while cookie consent
     * is still awaiting a choice. Temporarily close it.
     */
    if (isCookieBannerVisible() && dialog.open) {
      postponedNewsletter = true;
      dialog.close();
      return;
    }

    /*
     * The cookie banner is gone, so reopen the newsletter
     * only when this function previously postponed it.
     */
    if (
      !isCookieBannerVisible() &&
      postponedNewsletter &&
      !dialog.open
    ) {
      postponedNewsletter = false;

      try {
        dialog.showModal();
      } catch (error) {
        postponedNewsletter = true;
      }
    }
  }

  function observeCookieBanner(banner) {
    if (banner === observedBanner) return;

    if (bannerObserver) {
      bannerObserver.disconnect();
    }

    observedBanner = banner;

    if (!banner) return;

    bannerObserver = new MutationObserver(
      syncNewsletterWithCookieBanner
    );

    bannerObserver.observe(banner, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function observeNewsletterDialog(dialog) {
    if (dialog === observedDialog) return;

    if (dialogObserver) {
      dialogObserver.disconnect();
    }

    observedDialog = dialog;

    if (!dialog) return;

    dialogObserver = new MutationObserver(
      syncNewsletterWithCookieBanner
    );

    dialogObserver.observe(dialog, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  function prepareNewsletterConsentDelay() {
    observeCookieBanner(getCookieBanner());
    observeNewsletterDialog(getNewsletterDialog());
    syncNewsletterWithCookieBanner();
  }

  function initNewsletterConsentDelay() {
    prepareNewsletterConsentDelay();

    /*
     * Both Enzuzo and Klaviyo may inject their elements
     * after the initial page markup has loaded.
     */
    var insertionObserver = new MutationObserver(function (mutations) {
      var elementsAdded = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });

      if (elementsAdded) {
        prepareNewsletterConsentDelay();
      }
    });

    insertionObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initNewsletterConsentDelay
    );
  } else {
    initNewsletterConsentDelay();
  }
})();